import { defineMessages } from 'react-intl';

export default defineMessages({
  description:
    'This swap functionality only {deposited} in the Aave Protocol. For more information on the swap feature, please read the {faq}.',
  deposited: 'contains the assets you deposited',
  faq: 'FAQ',

  fromTitle: 'From',
  available: 'Available',
  toTitle: 'To',

  notEnoughBalance: 'Not enough balance to swap',

  continue: 'Continue',

  connectWallet: 'Please connect a wallet',
  connectWalletDescription: 'We couldn’t detect a wallet. Connect a wallet to swap',
});
